import type { Resource } from "@ferrivia/i18n";
import fi from "./locales/fi.json";
import en from "./locales/en.json";
import enUs from "./locales/en.us.json";

export const labUiResources: Resource = {
  fi: { labs: fi },
  en: { labs: en },
};

export const labUiUsOverlay: Resource = {
  en: { labs: enUs },
};
